// removed by extract-text-webpack-plugin
module.exports = {"media-thumbnail":"media-thumbnail","mediaThumbnail":"media-thumbnail","img":"img","remove-button":"remove-button","removeButton":"remove-button","remove-button__icon":"remove-button__icon","removeButtonIcon":"remove-button__icon","media-thumbnail--upload-pending":"media-thumbnail--upload-pending","mediaThumbnailUploadPending":"media-thumbnail--upload-pending","upload-status":"upload-status","uploadStatus":"upload-status","resource-type-icon":"resource-type-icon","resourceTypeIcon":"resource-type-icon"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContentSection/__future__/MediaUpload/MediaThumbnail.module.scss
// module id = 706
// module chunks = 0